exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input_error{border:1px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4077c908!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/product/editPro.vue
// module id = 585
// module chunks = 2